<template>
  <div>
    <common-header :menu="{}" />
    <h2 class="chart-title">実績</h2>
    <div style="min-height: 70vh">
      <div class="achievement-row">
        <achivement-item style="display: inline-block" v-for="a in achievements.continuous" :text="a.toString()" :key="a.toString()" />
      </div>
      <div class="achievement-row">
        <achivement-item style="display: inline-block" v-for="a in achievements.counts" :text="a.toString()" :key="a.toString()" />
      </div>
    </div>
    <common-footer :menu="{home:true,analytics:true}"/>
  </div>
</template>

<script>
// import * as Chart from 'chart.js'
import CommonHeader from "./CommonHeader";
import {RecordManager} from "./common/RecordManager";
import BarChartWithTitle from "./analytics/BarChartWithTitle";
import AnalyticsHeader from "./analytics/AnalyticsHeader";
import CommonFooter from "./CommonFooter";
import {AchievementManager} from "./common/achievement/AchievementManager";
import AchivementItem from "./common/achievement/AchivementItem";
import BasicButton from "./common/BasicButton";
export default {
  name: "AchivementList",
  components: {BasicButton, AchivementItem, CommonFooter, AnalyticsHeader, BarChartWithTitle, CommonHeader},
  head: {
  },
  data() {
    return {
      achievements: AchievementManager.getInstance().getAchievements(),
    }
  },
  mounted() {
    // window.ac = AchievementManager.getInstance()
    // window.rm = RecordManager.getInstance()
    // RecordManager.getInstance().debug()
  },
  // methods: {
  //   init() {
  //     const ctx = document.getElementById('myChart').getContext('2d');
  //     const myChart = new Chart(ctx, RecordManager.getInstance().getChartConfig());
  //     myChart.canvas.parentNode.className = 'chartParent'
  //   }
  // }
}
</script>

<style>
body {
  /*background: rgb(240,240,240);*/
}
</style>
<style scoped>
h2 {
  color: #e74a23;
  /*background: linear-gradient(124deg,#e74a23,#e9671f,#ec841b,#efa118);*/
  padding: 1.8vh 0;
  font-size: 4vh;
  border-bottom: 4px solid #e74a23;
}
.achievement-row {
  margin: 1vh 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AchievementList.vue